let datemMnthYr = new Date(),
currentdate = datemMnthYr.getFullYear() + '-' + ('0'+(datemMnthYr.getMonth() + 1)).slice(-2) + '-' + datemMnthYr.getDate() ;

let datetime = new Date(),
currenttime = datetime.getHours() + ':' + datetime.getMinutes() + ':' + datetime.getSeconds();
export { currentdate,currenttime }